var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPointingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 385,
    viewBox: "0 0 426 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.382 350.929L29.0903 48.3941C23.6174 38.7279 30.6002 26.75 41.7082 26.75L384.292 26.75C395.4 26.75 402.383 38.7279 396.91 48.3941L225.618 350.929C220.065 360.737 205.935 360.737 200.382 350.929Z",
    stroke: "white",
    strokeWidth: 53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointingDown);
export default __webpack_public_path__ + "static/media/arrow_pointing_down.42a6bf012c079d557f73e2caf17d24a5.svg";
export { ForwardRef as ReactComponent };